import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng/ui_base';
import { Share } from '@ifeng/ui_pc_share';
import errorBoundary from '@ifeng/errorBoundary';

const config = {
    items: ['sina', 'wechat', 'qqzone'],
    display: 'gray',
    hover: 'filling',
    type: 'vertical',
    methods: 'hover',
    tooltip: 'left',
};

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isShow: false,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (currentTop > 100) {
            this.setState({ isShow: true });
        } else {
            this.setState({ isShow: false });
        }
    };

    /**
     * 回到顶部
     */
    backToTop = () => {
        scrollTo(0, 0);
    };

    /**
     * 渲染组件
     */
    render() {
        const { isShow } = this.state;
        const {
            content: { title, summery, imagesInContent, pcUrl },
        } = this.props;
        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const affix = (
            <div className={styles.affix_box}>
                <div className={styles.bottom_affix}>
                    <div className={styles.share}>
                        <Share config={config} shareInfo={shareInfo} />
                    </div>
                    {isShow ? <span className={styles.backToTop} onClick={this.backToTop} /> : ''}
                </div>
            </div>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
